<div #body class="sb-item-body" [style.height]="height">
    <div class="card-body">
    	<ng-content></ng-content>
    </div>
</div>


// WEBPACK FOOTER //
// ./node_modules/ng-mdb-pro/pro/accordion/components/sb-item.body.html